

















































































































































import { Component, Vue } from "vue-property-decorator";
import PatientCalendarEventForm from "@/views/patient_calendar/PatientCalendarEventForm.vue";
import { FullPatientCalendar, FullPatientCalendarEvents } from "@/api";
import moment from "moment";
import { addDayOnDate } from "@/common/date_format";
import { selfData } from "@/common/role_utils";

type CustomDate = {
  date: string;
};

type CustomEvent = {
  id?: number;
  name: string;
  description: string;
  start: Date;
  end: Date;
  time: string;
  color: string;
  patient: string;
  location: string;
  eventTypeId: number;
  timed: boolean;
  eventType: string;
  eventColor: string;
};

@Component({
  components: {
    PatientCalendarEventForm,
  },
})
export default class PatientCalendarlayout extends Vue {
  counter = 0;
  currentMonth = "";
  loading = false;
  deleting = false;
  isUpdate = false;
  eventDialog = false;
  eventTypeDialog = false;
  type = "month";
  types = ["month", "week", "day"];
  typeIcon = "mdi-view-grid";
  typeIcons = ["mdi-view-grid", "mdi-view-column", "mdi-view-agenda"];
  typeIndex = 0;
  value = "";
  selectedOpen = false;
  selectedElement: EventTarget | null = null;
  selectedEvent: CustomEvent = {
    name: "",
    description: "",
    start: new Date(),
    end: new Date(),
    time: "",
    color: "",
    patient: "",
    location: "",
    eventTypeId: 0,
    timed: true,
    eventType: "",
    eventColor: "",
  };

  async created() {
    this.loading = true;
    const eventsTypes = this.$store.dispatch(
      "patientCalendar/fetchCalendarEventTypes",
    );
    await Promise.all([eventsTypes]);
    this.loading = false;
  }

  get events() {
    const events: CustomEvent[] = [];
    const eventList =
      (this.$store.getters[
        "patientCalendar/patientCalendarEvents"
      ] as FullPatientCalendarEvents) || [];

    eventList.forEach(item => {
      events.push({
        // eslint-disable-next-line
        id: item.patientCalendar.id!,
        name: item.patientCalendar.title,
        description: item.patientCalendar.description,
        start: moment
          .utc(item.patientCalendar.date)
          .local()
          .toDate(),
        end: moment
          .utc(item.patientCalendar.date)
          .local()
          .toDate(),
        time: moment(item.patientCalendar.date).format("HH:mm"),
        color: item.eventType.color,
        patient: item.patientCalendar.patient,
        location: item.patientCalendar.location,
        eventTypeId: item.eventType.id,
        eventType: item.eventType.type,
        eventColor: item.eventType.color,
        timed: true,
      });
    });

    return events;
  }

  getEvents({ start, end }: { start: CustomDate; end: CustomDate }) {
    if (this.type != "month") return;
    this.currentMonth = moment(start.date).format("MMMM YYYY");
    this.$store.dispatch("patientCalendar/fetchPatientCalendarEvents", {
      beginAt: start.date,
      endAt: addDayOnDate(end.date),
      force: true,
    });
  }

  viewDay({ date }: { date: string }) {
    this.value = date;
    this.typeIndex = 1;
    this.changeIcon(false);
  }

  changeIcon(isDay: boolean) {
    this.typeIndex++;
    if (this.typeIndex >= this.types.length) this.typeIndex = 0;
    if (isDay) this.value = moment().format("YYYY-MM-DD");
    this.type = this.types[this.typeIndex];
    this.typeIcon = this.typeIcons[this.typeIndex];
  }

  showEvent({
    nativeEvent,
    event,
  }: {
    nativeEvent: MouseEvent | TouchEvent;
    event: CustomEvent;
  }) {
    const open = () => {
      this.selectedEvent = event;
      this.selectedElement = nativeEvent.target;
      requestAnimationFrame(() =>
        requestAnimationFrame(() => (this.selectedOpen = true)),
      );
    };

    if (this.selectedOpen) {
      this.selectedOpen = false;
      requestAnimationFrame(() => requestAnimationFrame(() => open()));
    } else {
      open();
    }

    nativeEvent.stopPropagation();
  }

  getEventDateFormatted(date: string) {
    const format = "MM/DD/YYYY @ HH:mm:ss";
    return moment(date)
      .local()
      .format(format);
  }

  clearSelectedEvent() {
    this.selectedEvent = {
      name: "",
      description: "",
      start: new Date(),
      end: new Date(),
      time: "",
      color: "",
      patient: "",
      location: "",
      eventTypeId: 0,
      timed: true,
      eventType: "",
      eventColor: "",
    };
  }

  async deleteEvent() {
    this.deleting = true;
    const payload: FullPatientCalendar = {
      patientCalendar: {
        id: this.selectedEvent.id,
        companyID: selfData().companyId,
        createdByID: selfData().id,
        title: this.selectedEvent.name,
        description: this.selectedEvent.description,
        date: moment
          .utc(this.selectedEvent.start)
          .local()
          .format(),
        time: this.selectedEvent.time,
        eventTypeID: this.selectedEvent.eventTypeId,
        patient: this.selectedEvent.patient,
        location: this.selectedEvent.location,
        createdAt: moment()
          .utc()
          .toISOString(),
      },
      eventType: {
        id: this.selectedEvent.eventTypeId,
        type: this.selectedEvent.eventType,
        color: this.selectedEvent.eventColor,
      },
      createdBy: {
        id: selfData().id,
        name: `${selfData().firstName} ${selfData().lastName}`,
      },
    };
    await this.$store.dispatch(
      "patientCalendar/deletePatientCalendarEvent",
      payload,
    );
    this.deleting = false;
    this.selectedOpen = false;
  }
}
